// Typelizer digest b1d553bf86f21250f57c689594effb9a
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/classes/:class_id/teacher_class_listing_availability/edit */
  edit: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/teacher_class_listing_availability/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/classes/:class_id/teacher_class_listing_availability */
  update: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/teacher_class_listing_availability', params, options),
    method: 'patch',
  }),
}
